import React from "react";
import WatchClassTemplate from "../../templates/watchClassTemplate/WatchClassTemplate";

export default function WatchClassPage() {
    return (
        <WatchClassTemplate />
    );
}